import React from "react";
import { Image, ImageBackground, StyleSheet, Text, View } from "react-native";
import {
  AvatarFrameVipPng,
  AvatarModalPng,
  NamePng,
  ProfileScore,
  RedChipsPng,
  VipBadgeFramePng,
} from "../../../assets";
import { isPortrait } from "../../../utils/common";
import { isDesktop } from "@rnv/renative";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

type Props = {
  name: string;
  score: number;
  chips: string;
  avatarImage: any;
  backgroundImage: any;
};

const InvitedPlayerCard = ({
  name,
  score,
  chips,
  avatarImage,
  backgroundImage,
}: Props) => {
  const isVip = useSelector((s: RootState) => s.auth.user?.isVip);
  return (
    <ImageBackground
      source={backgroundImage}
      resizeMode="stretch"
      style={[
        styles.cardBackground,
        {
          paddingRight: isPortrait ? 12 : 0,
          marginLeft: isPortrait ? 4 : 14,
          marginBottom: isPortrait ? 0 : 0,
        },
      ]}
    >
      <View
        style={[
          styles.container,
          {
            gap: isPortrait ? 2 : 4,
          },
        ]}
      >
        {/* Avatar */}
        {/* <View
          style={[
            styles.avatarWrapper,
            {
              width: isPortrait ? 35 : 120,
              marginLeft: isPortrait ? 0 : -10,
            },
          ]}
        >
          <ImageBackground
            source={AvatarModalPng}
            style={{
              width: isPortrait ? 76 : 60,
              height: isPortrait ? 56 : 60,
              position: "relative",
              left: isPortrait ? -11 : -38,
            }}
            resizeMode="contain"
          />
          <Image
            source={avatarImage}
            style={{
              width: isPortrait ? 66 : 52,
              height: isPortrait ? 50 : 46,
              position: "absolute",
              top: isPortrait ? 10 : 7,
              left: isPortrait ? -30 : -4,
            }}
            resizeMode="contain"
          />
          <Image
            source={ProfileScore}
            style={[
              styles.scoreBadge,
              {
                width: isPortrait ? 26 : 26,
                height: isPortrait ? 26 : 26,
                top: isPortrait ? 16 : 17,
                left: isPortrait ? 16 : 36,
              },
            ]}
            resizeMode="contain"
          />
          <Text
            style={{
              width: 38,
              height: 38,
              position: "absolute",
              top: isPortrait ? 26 : 21,
              left: isPortrait ? 63 : 43,
              color: "#fff",
              fontSize: isPortrait ? 14 : 12,
              fontWeight: "600",
            }}
          >
            {score}
          </Text>
        </View> */}
        <View
          style={{
            width: isPortrait ? 76 : 60,
            height: isPortrait ? 56 : 60,
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: -10,
          }}
        >
          <Image
            source={isVip ? AvatarFrameVipPng : AvatarModalPng}
            style={isVip ? styles.avatarVip : styles.avatarLogoBg}
            // style={{
            //   width: "100%",
            //   height: "100%",
            //   position: "absolute",
            //   top: 0,
            //   left: 0,
            // }}
            resizeMode="contain"
          />

          <Image
            source={avatarImage}
            style={{
              width: isPortrait ? 46 : 42,
              height: isPortrait ? 46 : 42,
              borderRadius: (isPortrait ? 46 : 42) / 2,
            }}
            resizeMode="cover"
          />
          {isVip && (
            <Image
              source={VipBadgeFramePng}
              style={{
                position: "absolute",
                top: 18,
                left: isPortrait ? 50 : 40,
                width: 25,
                height: 25,
                zIndex: 22,
              }}
            />
          )}

          {/* <Image
            source={ProfileScore}
            style={{
              position: "absolute",
              width: 26,
              height: 26,
              top: isPortrait ? 18 : 16,
              right: isPortrait ? 2 : -2,
            }}
            resizeMode="contain"
          />

          <View
            style={{
              position: "absolute",
              width: 26,
              height: 26,
              top: isPortrait ? 18 : 16,
              right: isPortrait ? 2 : -2,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                color: "#fff",
                fontSize: isPortrait ? 14 : 12,
                fontWeight: "600",
                lineHeight: isPortrait ? 14 : 12,
              }}
            >
              {score}
            </Text>
          </View> */}
        </View>

        {/* Name */}
        <View style={[styles.nameWrapper, { marginTop: isPortrait ? 5 : 1 }]}>
          <ImageBackground
            source={NamePng}
            style={{
              width: isPortrait ? 120 : 190,
              height: isPortrait ? 30 : 28,
            }}
            resizeMode="stretch"
          >
            <Text
              style={{
                // position: "absolute",
                // top: 4,
                // left: isPortrait ? 20 : 50,
                flex: 1,
                color: "white",
                fontSize: isPortrait ? 14 : 14,
                fontWeight: "500",
                marginLeft: 3,
                marginTop: 4,
                paddingLeft: 4,
                // width: isPortrait ? 100 : 120,
              }}
            >
              {name}
            </Text>
          </ImageBackground>
        </View>

        {/* Chips */}
        <View
          style={[
            styles.statsItem,
            { marginTop: isPortrait ? 2 : 6, justifyContent: "center" },
          ]}
        >
          <Image
            source={RedChipsPng}
            resizeMode="contain"
            style={styles.statsIcon}
          />
          <Text style={styles.statsText}>{chips}</Text>
        </View>
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  cardBackground: {
    borderRadius: 12,
    marginBottom: 6,

    height: 60,
    marginLeft: 4,
  },
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  avatarWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  avatarBg: {
    position: "relative",
  },
  avatarLogoBg: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
  },
  avatarVip: {
    width: "85%",
    height: "85%",
    position: "absolute",
    top: 4,
    left: 5,
  },
  avatarImage: {
    width: isPortrait ? 92 : 130,
    height: isPortrait ? 58 : 76,
    position: "absolute",
    top: isPortrait ? 7 : 13,
    left: isPortrait ? 10 : -5,
  },
  scoreBadge: {
    width: isPortrait ? 32 : 38,
    height: isPortrait ? 32 : 38,
    position: "absolute",
    top: isPortrait ? 20 : 30,
    left: isPortrait ? 76 : 88,
  },
  scoreText: {
    width: 38,
    height: 38,
    position: "absolute",
    top: isPortrait ? 26 : 36,
    left: isPortrait ? 86 : 98,
    color: "#fff",
    fontSize: isPortrait ? 14 : 18,
    fontWeight: "600",
  },
  nameWrapper: {
    position: "relative",
  },
  nameBg: {
    width: isPortrait ? 120 : 224,
    height: isPortrait ? 30 : 38,
  },
  nameText: {
    position: "absolute",
    top: 4,
    left: isPortrait ? 20 : 60,
    flex: 1,
    color: "white",
    fontSize: isPortrait ? 14 : 20,
    fontWeight: "500",
    marginLeft: 3,
    width: isPortrait ? 100 : 120,
  },
  statsItem: {
    flexDirection: "row",
    alignItems: "center",
    width: isPortrait ? 90 : 160,
  },
  statsIcon: {
    width: isPortrait ? 24 : 34,
    height: isPortrait ? 24 : 34,
  },
  statsText: {
    color: "white",
    fontSize: 14,
    marginLeft: 2,
    fontWeight: "bold",
  },
});

export default InvitedPlayerCard;
